import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const alltrailsLink = (
  <Link href="/" target="_blank">
    AllTrails
  </Link>
);

const alltrailsDotComLink = (
  <Link href="/" target="_blank">
    Alltrails.com
  </Link>
);

const pressLink = <Link href="mailto:press@alltrails.com">press@alltrails.com</Link>;

const appOfTheYearLink = (
  <Link href="https://www.prnewswire.com/news-releases/alltrails-named-apples-2023-iphone-app-of-the-year-302001617.html" target="_blank">
    <FormattedMessage defaultMessage="Apple's iPhone App of the Year" />
  </Link>
);

// Most Outstanding
const islandLakeAndIceLikeLink = (
  <Link href="https://www.alltrails.com/trail/us/colorado/island-lake-and-ice-lake-via-ice-lakes-trail" target="_blank">
    <FormattedMessage defaultMessage="Island Lake and Ice Lake via Ice Lakes Trail" />
  </Link>
);

const lakeOharaAlpineLink = (
  <Link href="https://www.alltrails.com/trail/canada/british-columbia/lake-ohara-alpine-circuit" target="_blank">
    <FormattedMessage defaultMessage="Lake O'Hara Alpine Circuit" />
  </Link>
);

const skogafossLink = (
  <Link href="https://www.alltrails.com/trail/iceland/southern/skogafoss-skalabrekkufoss-waterfalls" target="_blank">
    <FormattedMessage defaultMessage="Skógafoss -Skálabrekkufoss Waterfalls" />
  </Link>
);

const kingsCanyonRimAndCreekWalksLink = (
  <Link href="https://www.alltrails.com/trail/australia/northern-territory/kings-canyon-rim-and-creek-walks-via-cotterills-lookout" target="_blank">
    <FormattedMessage defaultMessage="Kings Canyon Rim and Creek Walks via Cotterills Lookout" />
  </Link>
);

const mostOutstanding = (
  <Typography variant="text100">
    <Typography variant="text100bold" component="span">
      <FormattedMessage defaultMessage="Most Outstanding" />
    </Typography>{' '}
    <em>
      <FormattedMessage defaultMessage="(Highest Rated Trails Overall)" />
    </em>
    <ol>
      <li>
        <FormattedMessage defaultMessage="United States, Durango, Colorado: {islandLakeAndIceLikeLink}" values={{ islandLakeAndIceLikeLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Canada, Lake Louise, Alberta: {lakeOharaAlpineLink}" values={{ lakeOharaAlpineLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Iceland, Skógar, Southern: {skogafossLink}" values={{ skogafossLink }} />
      </li>
      <li>
        <FormattedMessage
          defaultMessage="Australia, Kings Canyon, Northern Territory: {kingsCanyonRimAndCreekWalksLink}"
          values={{ kingsCanyonRimAndCreekWalksLink }}
        />
      </li>
    </ol>
  </Typography>
);

// Most Athletic
const theWonderlandTrailLink = (
  <Link href="https://www.alltrails.com/trail/us/washington/the-wonderland-trail" target="_blank">
    <FormattedMessage defaultMessage="The Wonderland Trail" />
  </Link>
);
const stCuthbertsWayLink = (
  <Link href="https://www.alltrails.com/trail/scotland/scottish-borders/st-cuthbert-s-way" target="_blank">
    <FormattedMessage defaultMessage="St Cuthbert’s Way" />
  </Link>
);
const theDingleWayLink = (
  <Link href="https://www.alltrails.com/trail/ireland/county-kerry/the-dingle-way" target="_blank">
    <FormattedMessage defaultMessage="The Dingle Way: Complete" />
  </Link>
);
const larapintaTrailLink = (
  <Link href="https://www.alltrails.com/trail/australia/northern-territory/larapinta-trail" target="_blank">
    <FormattedMessage defaultMessage="Larapinta Trail" />
  </Link>
);

const mostAthletic = (
  <Typography variant="text100">
    <Typography variant="text100bold" component="span">
      <FormattedMessage defaultMessage="Most Athletic" />
    </Typography>{' '}
    <em>
      <FormattedMessage defaultMessage="(Highest Rated Trails Frequented for Trail Running)" />
    </em>
    <ol>
      <li>
        <FormattedMessage defaultMessage="United States, Longmire, Washington: {theWonderlandTrailLink}" values={{ theWonderlandTrailLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Scotland, Melrose, Scottish Borders: {stCuthbertsWayLink}" values={{ stCuthbertsWayLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Ireland, Tralee, County Kerry: {theDingleWayLink}" values={{ theDingleWayLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Australia, Alice Springs, Northern Territory: {larapintaTrailLink}" values={{ larapintaTrailLink }} />
      </li>
    </ol>
  </Typography>
);

// Most Beautiful
const sawToothLakeLink = (
  <Link href="https://www.alltrails.com/trail/us/idaho/sawtooth-lake-via-iron-creek-stanley-lake-trail" target="_blank">
    <FormattedMessage defaultMessage="Sawtooth Lake via Iron Creek Stanley Lake Trail" />
  </Link>
);
const panoramaRidgeLink = (
  <Link href="https://www.alltrails.com/trail/canada/british-columbia/panorama-ridge" target="_blank">
    <FormattedMessage defaultMessage="Panorama Ridge" />
  </Link>
);
const besseggenLink = (
  <Link href="https://www.alltrails.com/trail/norway/innlandet/besseggen" target="_blank">
    <FormattedMessage defaultMessage="Besseggen" />
  </Link>
);
const oeschinenseeRundwegLink = (
  <Link href="https://www.alltrails.com/trail/switzerland/bern/oeschinensee-rundweg" target="_blank">
    <FormattedMessage defaultMessage="Oeschinensee Rundweg" />
  </Link>
);

const mostBeautiful = (
  <Typography variant="text100">
    <Typography variant="text100bold" component="span">
      <FormattedMessage defaultMessage="Most Beautiful" />
    </Typography>{' '}
    <em>
      <FormattedMessage defaultMessage="(Highest Rated Trails with Stunning Views)" />
    </em>
    <ol>
      <li>
        <FormattedMessage defaultMessage="United States, Stanley, Idaho: {sawToothLakeLink}" values={{ sawToothLakeLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Canada, Garibaldi, British Columbia: {panoramaRidgeLink}" values={{ panoramaRidgeLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Norway, Lom, Innlandet: {besseggenLink}" values={{ besseggenLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Switzerland, Kandersteg, Bern: {oeschinenseeRundwegLink}" values={{ oeschinenseeRundwegLink }} />
      </li>
    </ol>
  </Typography>
);

// Family Favorite
const congressTrailLink = (
  <Link href="https://www.alltrails.com/trail/us/california/congress-trail-via-generals-highway-trailhead" target="_blank">
    <FormattedMessage defaultMessage="Congress Trail via Generals Highway Trailhead" />
  </Link>
);
const stanleyParkSeawallLink = (
  <Link href="https://www.alltrails.com/trail/canada/british-columbia/stanley-park-seawall-trail" target="_blank">
    <FormattedMessage defaultMessage="Stanley Park Seawall" />
  </Link>
);
const avenidaDeLaReformaLink = (
  <Link href="https://www.alltrails.com/trail/mexico/state-of-mexico-4/ciudad-de-mexico-avenida-de-la-reforma" target="_blank">
    <FormattedMessage defaultMessage="Ciudad de México: Avenida de la Reforma" />
  </Link>
);
const fewstonReservoiorCircularLink = (
  <Link href="https://www.alltrails.com/trail/england/west-yorkshire/fewston-reservoir-circular" target="_blank">
    <FormattedMessage defaultMessage="Fewston Reservoir Circular" />
  </Link>
);

const familyFavorite = (
  <Typography variant="text100">
    <Typography variant="text100bold" component="span">
      <FormattedMessage defaultMessage="Most Family-Friendly" />
    </Typography>{' '}
    <em>
      <FormattedMessage defaultMessage="(Highest Rated Trails for the Whole Family)" />
    </em>
    <ol>
      <li>
        <FormattedMessage defaultMessage="United States, Hartland, California: {congressTrailLink}" values={{ congressTrailLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Canada, Vancouver, British Columbia: {stanleyParkSeawallLink}" values={{ stanleyParkSeawallLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="México, México City, State of Mexico: {avenidaDeLaReformaLink}" values={{ avenidaDeLaReformaLink }} />
      </li>
      <li>
        <FormattedMessage
          defaultMessage="England, Otley, West Yorkshire: {fewstonReservoiorCircularLink}"
          values={{ fewstonReservoiorCircularLink }}
        />
      </li>
    </ol>
  </Typography>
);

// The All-Nighter
const skyPondTheLochTimberlineFallsLink = (
  <Link href="https://www.alltrails.com/trail/us/colorado/timberline-falls-and-sky-pond-trail" target="_blank">
    <FormattedMessage defaultMessage="Sky Pond, The Loch, and Timberline Falls via Glacier Gorge Loop" />
  </Link>
);
const kainHutTrailLink = (
  <Link href="https://www.alltrails.com/trail/canada/british-columbia/kain-hut-trail-to-applebee-campground" target="_blank">
    <FormattedMessage defaultMessage="Kain Hut Trail to Applebee Campground" />
  </Link>
);
const caminoIncaLink = (
  <Link href="https://www.alltrails.com/trail/peru/cusco/camino-inca" target="_blank">
    <FormattedMessage defaultMessage="Camino Inca" />
  </Link>
);
const mountBourgeauTrailLink = (
  <Link href="https://www.alltrails.com/trail/canada/alberta/mount-bourgeau-trail--2?u=i" target="_blank">
    <FormattedMessage defaultMessage="Mount Bourgeau Trail" />
  </Link>
);

const theAllNighter = (
  <Typography variant="text100">
    <Typography variant="text100bold" component="span">
      <FormattedMessage defaultMessage="The All-Nighter" />
    </Typography>{' '}
    <em>
      <FormattedMessage defaultMessage="(Highest Rated Trails for Overnight Trips)" />
    </em>
    <ol>
      <li>
        <FormattedMessage
          defaultMessage="United States, Estes Park, Colorado: {skyPondTheLochTimberlineFallsLink}"
          values={{ skyPondTheLochTimberlineFallsLink }}
        />
      </li>
      <li>
        <FormattedMessage defaultMessage="Canada, Spillimacheen, British Columbia: {kainHutTrailLink}" values={{ kainHutTrailLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Peru, Ollantaytambo, Cusco: {caminoIncaLink}" values={{ caminoIncaLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Canada, Banff National Park: {mountBourgeauTrailLink}" values={{ mountBourgeauTrailLink }} />
      </li>
    </ol>
  </Typography>
);

// Most Fun for All
const burneyFallsLoopLink = (
  <Link href="https://www.alltrails.com/trail/us/california/burney-falls-loop-trail" target="_blank">
    <FormattedMessage defaultMessage="Burney Falls Loop" />
  </Link>
);
const sanJosefBayLink = (
  <Link href="https://www.alltrails.com/trail/canada/british-columbia/san-josef-bay" target="_blank">
    <FormattedMessage defaultMessage="San Josef Bay" />
  </Link>
);
const uluruBaseWalkLink = (
  <Link href="https://www.alltrails.com/trail/australia/northern-territory/uluru-base-walk" target="_blank">
    <FormattedMessage defaultMessage="Uluru Base Walk" />
  </Link>
);
const eibseeRundwegLink = (
  <Link href="https://www.alltrails.com/trail/germany/bavaria/eibsee-rundweg--3" target="_blank">
    <FormattedMessage defaultMessage="Eibsee Rundweg" />
  </Link>
);

const mostFunForAll = (
  <Typography variant="text100">
    <Typography variant="text100bold" component="span">
      <FormattedMessage defaultMessage="Most Fun for All" />
    </Typography>{' '}
    <em>
      <FormattedMessage defaultMessage="(Highest Rated Accessible Trails)" />
    </em>
    <ol>
      <li>
        <FormattedMessage defaultMessage="United States, Cassel, California: {burneyFallsLoopLink}" values={{ burneyFallsLoopLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Canada, Holberg, British Columbia: {sanJosefBayLink}" values={{ sanJosefBayLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Australia, Uluru, Northern Territory: {uluruBaseWalkLink}" values={{ uluruBaseWalkLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Germany, Grainau, Bayern: {eibseeRundwegLink}" values={{ eibseeRundwegLink }} />
      </li>
    </ol>
  </Typography>
);

// Rookie of the Year
const campSummerLandLink = (
  <Link href="https://www.alltrails.com/trail/us/washington/camp-summerland-and-panhandle-gap-via-wonderland-trail" target="_blank">
    <FormattedMessage defaultMessage="Camp Summerland and Panhandle Gap via Wonderland Trail" />
  </Link>
);
const cradleSummitLink = (
  <Link href="https://www.alltrails.com/trail/australia/tasmania/cradle-summit" target="_blank">
    <FormattedMessage defaultMessage="Cradle Summit" />
  </Link>
);
const rifugioCitelliLink = (
  <Link href="https://www.alltrails.com/trail/italy/campania/rifugio-citelli-grotta-serracozzo" target="_blank">
    <FormattedMessage defaultMessage="Rifugio Citelli - Grotta Serracozzo" />
  </Link>
);
const threePeaksLink = (
  <Link href="https://www.alltrails.com/trail/england/north-yorkshire/three-peaks-pen-y-ghent" target="_blank">
    <FormattedMessage defaultMessage="Three Peaks: Pen-y-ghent" />
  </Link>
);

const rookieOfTheYear = (
  <Typography variant="text100">
    <Typography variant="text100bold" component="span">
      <FormattedMessage defaultMessage="Rookie of the Year*" />
    </Typography>{' '}
    <em>
      <FormattedMessage defaultMessage="(Highest Rated New Trails)" />
    </em>
    <ol>
      <li>
        <FormattedMessage defaultMessage="United States, Ashford, Washington: {campSummerLandLink}" values={{ campSummerLandLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Australia, Cradle Mountain, Tasmania: {cradleSummitLink}" values={{ cradleSummitLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="Italy, Sant'Alfio, Sicily: {rifugioCitelliLink}" values={{ rifugioCitelliLink }} />
      </li>
      <li>
        <FormattedMessage defaultMessage="England, Austwick, North Yorkshire: {threePeaksLink}" values={{ threePeaksLink }} />
      </li>
    </ol>
  </Typography>
);

const pressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <FormattedMessage defaultMessage="AllTrails Unveils ‘2023 Year on the Trails,’ Revealing Top Global Hiking Data from the Year" />,
  date: 'January 15 2024',
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <FormattedMessage defaultMessage="AllTrails Unveils ‘2023 Year on the Trails,’ Revealing Top Global Hiking Data from the Year" />
      </Typography>
      <Typography variant="paragraph100">
        <FormattedMessage
          defaultMessage="Just weeks after being named {appOfTheYearLink}, {alltrailsLink} released their ‘Year on the Trails’ report, a comprehensive overview of the app’s highest-rated trails of 2023. Compiled by AllTrails’ team of trail experts, the report unveils the AllTrails community’s top trails. The list is a global compilation of users’ favorite routes; it offers the “best of” AllTrails’ 420 thousand trail routes, based on input from the app’s community of more than 60 million walkers, hikers, and nature enthusiasts."
          values={{ appOfTheYearLink, alltrailsLink }}
        />
        <br />
        <FormattedMessage defaultMessage="“The ‘2023 Year on the Trails’ report allows us to celebrate an exciting year of discovery and adventure,” said Carly Smith, Chief Marketing Officer at AllTrails. “Our global community of trail-goers shared valuable insights about their time outside by reviewing more than 250 thousand trails, from Peru to Switzerland and from Canada to Australia. Each and every one of these adventures serve as helpful guidance or exciting inspiration for others planning their trail activities.”" />
        <br />
        <FormattedMessage defaultMessage="AllTrails’ team of trail and data experts reviewed thousands of data points across its extensive database. The top trails in each category were selected based on AllTrails community members' average star ratings of trails in the past year. The top 2023 global trails include:" />
      </Typography>

      {mostOutstanding}
      {mostAthletic}
      {mostBeautiful}
      {rookieOfTheYear}
      {familyFavorite}
      {theAllNighter}
      {mostFunForAll}

      <Typography variant="paragraph100">
        <FormattedMessage defaultMessage="“Our top trails report is thanks to AllTrails’ global, engaged, and growing community,” said Ron Schneidermann, Chief Executive Officer at AllTrails. “We’re inspired by our users’ experiences on the trails and grateful for the opportunity to compile this report based on millions of people’s real-life experiences,” he added. “We’re excited to make it even easier and more fun for users to share reviews in 2024 — stay tuned.”" />
        <br />
        <FormattedMessage defaultMessage="AllTrails is home to the largest collection of digital trail guides and has routes in every country. In 2024 the platform will be unveiling additional features that will make it even easier and more fun to get outside." />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="About AllTrails" />
        </Typography>
        <br className={styles.noMargin} />
        <FormattedMessage
          defaultMessage="AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of trail-goers. Every day, AllTrails is inspired to help get more people outside so they can have healthy, authentic experiences and a deeper appreciation of the outdoors. AllTrails is Apple’s 2023 iPhone App of the Year and was awarded a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to {alltrailsDotComLink} to learn more."
          values={{ alltrailsDotComLink }}
        />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="Press Contact:" />
        </Typography>{' '}
        {pressLink}
        <br />
        <em>
          *Rookie of the Year refers to the highest user-rated trails that were added to the AllTrails platform within the last year. While these
          trails include reviews from years prior, we’ve only analyzed ratings from the year prior.
        </em>
      </Typography>
    </>
  )
};

export default pressRelease;
